import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cb14401"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-select-field" }
const _hoisted_2 = { class: "custom-select-field__selected-value" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "custom-select-field__list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "value" }
const _hoisted_7 = {
  key: 0,
  class: "triangle triangle--reverse"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "custom-select-field__preview",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle(true)))
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.selectedItem.value), 1),
      _hoisted_3
    ]),
    (_ctx.isOpen)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsWithSelectedFirst, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.key,
              class: _normalizeClass(["custom-select-field__item", {'custom-select-field__item--selected': item.key === _ctx.selectedKey }]),
              onClick: ($event: any) => (_ctx.select(item.key))
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.value), 1),
              (item.key === _ctx.selectedKey)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                : _createCommentVNode("", true)
            ], 10, _hoisted_5))
          }), 128))
        ])), [
          [_directive_click_outside, () => _ctx.toggle()]
        ])
      : _createCommentVNode("", true)
  ]))
}